import { ApiBase } from "config";
import {
  IindustryWiseMemberResult,
  IMemberLoginHistory,
  IMemberLoginHistoryPostModel,
  IMemberStatusCountGridPostModel,
  IMemberStatusResult,
  IMemberWiseTableResults,
} from "./types";
import api from "utils/api";

const baseUrl = `${ApiBase}/api/Dashboard`;

function getMemberStatusCount(model: IMemberStatusCountGridPostModel) {
  return api.post<IMemberStatusResult>(
    `${baseUrl}/getTotalMembers`,
    model.filter
  );
}

function getLogedInMembers(model: IMemberLoginHistoryPostModel) {
  return api.post<IMemberLoginHistory>(
    `${baseUrl}/getLogedInMembers`,
    model.filter
  );
}

function getMemberWiseTables() {
  return api.get<IMemberWiseTableResults>(
    `${baseUrl}/getMemberWiseTables`
  );
}

function getIndustryWiseMember() {
  return api.get<IindustryWiseMemberResult>(
    `${baseUrl}/getIndustryWiseMember`
  );
}

export default {
  getMemberStatusCount,
  getLogedInMembers,
  getMemberWiseTables,
  getIndustryWiseMember,
};
